export default __webpack_public_path__ + "static/media/gear.e83f6f1f.svg";